// src/components/Projects.js
import React, { useState, useRef, useEffect } from 'react';
import '../css/Projects.css';

const projectData = [
  {
    name: 'Mechanic Pro App',
    description: 'React Native + Flask app managing brake service appointments, boosted workflow efficiency by 40%.',
    link: 'https://github.com/ozXoz/py-react-native',
    category: 'Full Stack (Flask + React)',
    imageUrl: 'https://i.ibb.co/5kdQ1h8/Screenshot-2025-01-04-at-5-01-58-PM.png'
  },
  {
    name: 'TrioTeach-Backend-Ecom',
    description: 'Nodejs + express JS + React + Mongodb and other stuff',
    link: 'https://github.com/ozXoz/TrioTeach-Backend-Ecom',
    category: 'Full Stack (Node.js + React)',
    imageUrl: 'https://i.ibb.co/0Z2RGM0/Screenshot-2025-01-04-at-5-07-12-PM.png'
  },
  {
    name: 'TrioTeach-Frontend-Ecom',
    description: 'Nodejs + express JS + React + Mongodb and other stuff',
    link: 'https://github.com/ozXoz/TrioTeach-Frontend-Ecom-',
    category: 'Full Stack (Node.js + React)',
    imageUrl: 'https://i.ibb.co/6ry3rfL/Screenshot-2025-01-04-at-5-06-51-PM.png'
  },
  {
    name: 'TrioTeach-Backend-ERP',
    description: 'Nodejs + React MongoDb + Invoice app managing',
    link: 'https://github.com/ozXoz/TrioTeach-Backend-ERP',
    category: 'Full Stack (Node.js + React)',
    imageUrl: 'https://i.ibb.co/47Pg1m5/Screenshot-2025-01-04-at-5-03-56-PM.png'
  },
  {
    name: 'TrioTeach-Frontend-ERP',
    description: 'Nodejs + React MongoDb + Invoice app managing',
    link: 'https://github.com/ozXoz/TrioTeach-Frontend-ERP',
    category: 'Full Stack (Node.js + React)',
    imageUrl: 'https://i.ibb.co/qrt5rRd/Screenshot-2025-01-04-at-5-03-46-PM.png'
  },
  {
    name: 'Sword Garage Mechanic',
    description: 'Multilingual React landing page & mobile mechanic booking platform (Flask backend, JWT, 13+ reusable components). SEO optimized using React Helmet & sitemaps.',
    link: 'https://swordgarage.com',
    category: 'React',
    imageUrl: 'https://i.ibb.co/KjmY6F86/Screenshot-2025-02-05-at-2-49-03-PM.png'
  },
  {
    name: 'Nexyra Teach SaaS',
    description: 'React + Flask app managing Inventory, Sales & Order Management, plus advanced reporting.',
    link: 'https://www.nexyramanagement.ltd/',
    category: 'Full Stack (Flask + React)',
    imageUrl: 'https://i.ibb.co/TYDmkxs/Screenshot-2025-01-04-at-5-09-32-PM.png'
  },
  {
    name: 'Personal Portfolio I J.T',
    description: 'Portfolio built with React.',
    link: 'https://j3y-c1.vercel.app/',
    category: 'React',
    imageUrl: 'https://i.ibb.co/LdqZkb4/Screenshot-2025-01-04-at-5-11-30-PM.png'
  },
  {
    name: 'Personal Portfolio II A.S',
    description: 'React-based personal portfolio',
    link: 'https://client-saf1-hmet-portfolio.vercel.app/',
    category: 'React',
    imageUrl: 'https://i.ibb.co/xLrWHQ9/Screenshot-2025-01-04-at-5-11-40-PM.png'
  },
  {
    name: 'Personal Portfolio III R.W',
    description: 'React-based personal portfolio',
    link: 'https://client-wemigwans.vercel.app/',
    category: 'React',
    imageUrl: 'https://i.ibb.co/dfNLHJp/Screenshot-2025-01-04-at-5-11-46-PM.png'
  },
  {
    name: 'KaramizKaraEski – Personal AI Assistant',
    description: 'Multimodal assistant that answers questions with RAG, voice, and web‑search powers.',
    link: 'https://github.com/ozXoz/RamizKaraEski',   // change if hosted elsewhere
    category: 'AI / Full Stack',
    imageUrl: 'https://i.ibb.co/Q3tn33Dq/1.png'         // drop in your own thumbnail
  },
  {
    name: 'Voice Clone & Face Recognize',
    description: 'Realtime speaker cloning + face‑matching for authentication demos (React + Python gRPC).',
    link: 'https://ozaiclone.vercel.app/',
    category: 'AI / Computer‑Vision',
    imageUrl: 'https://i.ibb.co/twxNjV6Y/Screenshot-2025-05-09-at-11-05-28-AM.png'
  },
  {
    name: 'AI Code Tester',
    description: 'ChatGPT‑powered unit‑test generator that scores coverage and suggests refactors.',
    link: 'https://github.com/ozXoz/ai-code-tester',
    category: 'AI / DevTools',
    imageUrl: 'https://i.ibb.co/Zpy6dPCM/Screenshot-2025-05-09-at-11-07-27-AM.png'
  }
];

const Projects = () => {
  // State to hold the selected filter
  const [filter, setFilter] = useState('');

  // Intersection Observer states/refs
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  // Observe when the .projects section is scrolled into view
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setInView(true);
          // Unobserve after triggering once, or remove this line if you want it to toggle
          observer.unobserve(entries[0].target);
        }
      },
      {
        threshold: 0.3, // 30% of section visible triggers the effect
      }
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    // Cleanup if needed
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Filter the projects based on the selected category
  const filteredProjects = filter
    ? projectData.filter((project) => project.category === filter)
    : projectData;

  return (
    <section
      id="projects"
      ref={sectionRef}
      className={`projects ${inView ? 'projects-inview' : ''}`}
    >
      <h2>Featured Projects</h2>

      {/* Category filter dropdown */}
      <div className="filter-container">
        <label htmlFor="filterSelect" className="filter-label">Filter by:</label>
        <select
          id="filterSelect"
          onChange={(e) => setFilter(e.target.value)}
          value={filter}
          className="filter-select"
        >
          <option value="">All</option>
          <option value="React">React</option>
          <option value="Full Stack (Node.js + React)">
            Full Stack (Node.js + React)
          </option>
          <option value="Full Stack (Flask + React)">
            Full Stack (Flask + React)
          </option>
        </select>
      </div>

      <div className="projects-grid">
        {filteredProjects.map((project, index) => (
          <div className="project-card" key={index}>
            <img
              src={project.imageUrl}
              alt={project.name}
              className="project-image"
            />
            <h3>{project.name}</h3>
            <p>{project.description}</p>
            <a href={project.link} target="_blank" rel="noopener noreferrer">
              View Project
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
